import { h, Fragment } from 'preact';

import type {
  FormCheckboxControl,
  FormCheckboxOptionType,
} from 'src/types/form-config';
import { useSignalEffect } from '@preact/signals';
import { GlobalState } from '../../../states/global-state';
import { FormState } from '../../../states/kyc-form-state';

const CustomAddressCheckbox = (props: FormCheckboxControl) => {
  useSignalEffect(() => {
    const kycLoad = GlobalState.kycLoad.value;
    if (Object.keys(kycLoad).length) {
      FormState.sameAddress.value = ![
        kycLoad.homeAddress == kycLoad.officeAddress,
        kycLoad.homeCity == kycLoad.officeCity,
        kycLoad.homeCountry == kycLoad.officeCountry,
        kycLoad.homeFaxNumber == kycLoad.officeFaxNumber,
        kycLoad.homePhoneNumber == kycLoad.officePhoneNumber,
        kycLoad.homePostalCode == kycLoad.officePostalCode,
        kycLoad.homeProvince == kycLoad.officeProvince,
      ].includes(false);
    }
  });

  const onChangeHandler = e => {
    FormState.sameAddress.value = e.target.checked;
  };

  return (
    <div class="mb-4">
      {props.options.map((option: FormCheckboxOptionType) => {
        return (
          <div class="form-check" key={option.key}>
            <input
              class="form-check-input input"
              type="checkbox"
              data-value={option.value}
              name={props.name}
              id={props.name}
              checked={FormState.sameAddress.value}
              onChange={onChangeHandler}
            />
            <label class="form-check-label" for={props.name}>
              {option.display}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default CustomAddressCheckbox;
